<template>
  <div class="lp-check-single-container">
    <div class="lp-check-single-item" v-for="(item, idx) in list" :key="'check-single'+idx" :style="itemStyle">
      <div :class="{ 'checked-box' : item.value, 'not-checked-box' : !item.value }" @click.stop.prevent="clickCheck(idx)">
        <i v-if="item.value" class="material-icons checked-icon" @click.stop.prevent="clickCheck(idx)">check</i>
      </div>
      <div class="lp-check-single-label" @click.stop.prevent="clickCheck(idx)">{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    props:[ 'data', 'label', 'itemWidth' ],
    created() {
      this.list = this.data;
    },
    data() {
      return {
        list: [],
        checkedVal: ''
      }
    },
    computed: {
      itemStyle() {
        let style = {};

        style.width = this.itemWidth;

        return style;
      }
    },
    methods: {
      clickCheck(index) {
        for (let i=0; i<this.list.length; i++) {
          this.list[i].value = false;
        }
        this.list[index].value = true;
        this.$emit('onCheck', this.list[index]);
      }
    },
    watch: {
      list(n) {
        this.$emit('update:data', n);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_variable'
  .lp-check-single-container
    display flex

  .lp-check-single-item
    display flex

  .checked-box
  .not-checked-box
    position relative
    width 16px
    height 16px
    border 2px solid #008fd9
    border-radius 3px
    margin-right 8px
    text-align center

  .checked-box
    background-color $primary

  .not-checked-box
    background-color #fff

  .checked-icon
    color #fff
    font-size .8rem
    font-weight bold
    position absolute
    left 0px
    top 0px

  .lp-check-single-label
    font-size 0.9rem
    line-height 17px
    color #333
    // display flex

</style>
